import { Link } from "react-router-dom";

const ContactFooter = () => {
        window.scrollTo(0, 0);
  return (
    <>
      <div className="container mt-4 mb-5" style={{minHeight:"70vh"}}>
        <h2 className="text-center text-primary-new fw-bold mb-5">
          Contact Us
        </h2>

        <h4 className="text-primary-new fw-bold mb-4">General Inquiries</h4>

        <p className="text-dark">
          Reach our customer service team by phone at +1 (877) 487 4869 or email
          us at <Link to="#" className="text-primary fw-bold text-decoration-none">support@reachello.com</Link>
        </p>
      </div>
    </>
  );
};

export default ContactFooter;
